import { render, staticRenderFns } from "./MemberTrashedList.vue?vue&type=template&id=d520cb9e"
import script from "./MemberTrashedList.vue?vue&type=script&lang=js"
export * from "./MemberTrashedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports